module.exports = __webpack_public_path__ + "media/images/features/modification/heading-question-sm-8ccecea43a82bdfe01f721584dc3b99b.svg";